import { Roles } from '@/core/types';
import useAuth from '@/shared/context/auth-context';
import { FunctionComponent, ReactElement } from 'react';
import { Navigate } from 'react-router-dom';
import LeviantAdminUsersPage from './perspective/LeviantAdmin';
import CustomerUsersPage from './perspective/SiteSupervisor';

const UsersPage: FunctionComponent = (): ReactElement => {
	const { user } = useAuth();
	const { role } = user || {};

	if (role === Roles.LEVIANT_ADMIN) {
		return <LeviantAdminUsersPage />;
	}

	if (role === Roles.SITE_SUPERVISOR) {
		return <CustomerUsersPage />;
	}

	return <Navigate to="/" />;
};

export default UsersPage;
